// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Edit: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
            <path
                fill="currentColor"
                fillOpacity=".66"
                d="M13.614386,2.02788103 L11.9713002,0.384521484 C11.4586049,-0.128173828 10.6262611,-0.128173828 10.1138395,0.384521484 L8.56946416,1.93081021 L12.0448549,5.43081063 L13.5914174,3.88452148 C14.128449,3.37155247 14.128449,2.54057634 13.614386,2.02788103 Z M0.848683307,9.62780297 C0.787597546,9.68888915 0.745980272,9.76665461 0.728999743,9.85136533 L0.00876546829,13.4525375 C-0.0466329959,13.7293655 0.168261358,14.0000684 0.43606622,14.0000684 C0.464749703,14.0000684 0.493952641,13.9972388 0.523538599,13.9913099 L4.12471039,13.2710756 C4.20942152,13.2541468 4.28715945,13.2125329 4.34827275,13.1515018 L11.449445,6.05032957 L7.94944496,2.55032957 L0.848683307,9.62780297 Z M3.60657395,12.0367875 L1.55196459,12.447764 L1.96294112,10.3928814 L2.62493349,9.73170888 L2.62493349,11.3750684 L4.26883961,11.3750684 L3.60657395,12.0367875 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(Edit);
